import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
  const routes = [
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "type" */ '../views/Login.vue')
  },
  {
    path: '/order',
    name: 'Order',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "reserve" */ '../views/Order.vue')
  },
  {
    path: '/home',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "type" */ '../views/Home.vue')
  },
  {
    path: '/users',
    name: 'Users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
  },
  {
    path: '/account',
    name: 'Account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/Account.vue')
  },
  {
    path: '/logs/index',
    name: 'Logs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/logs/index.vue')
  },
  {
    path: '/logs/user',
    name: 'Logs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/logs/user.vue')
  },
  {
    path: '/branch',
    name: 'Branch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/Branch.vue')
  },
  {
    path: '/source',
    name: 'Source',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/Source.vue')
  },
  {
    path: '/bid/list',
    name: 'Project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/bid/list.vue')
  },
  {
    path: '/bid/feedback_list',
    name: 'Project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/bid/feedback_list.vue')
  },
  {
    path: '/bid/merchant_list',
    name: 'Project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/bid/merchant_list.vue')
  },
  {
    path: '/car/list',
    name: 'Car',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/car/list.vue')
  },
  {
    path: '/vin/list',
    name: 'VinList',
    component: () => import(/* webpackChunkName: "users" */ '../views/vin/list.vue')
  },
  {
    path: '/car/share',
    name: 'CarShare',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/car/share.vue')
  },
  {
    path: '/car/params',
    name: 'Car',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/car/params.vue')
  },
  {
    path: '/car/logs_list',
    name: 'Car',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/car/logs_list.vue')
  },
  {
    path: '/car/order_list',
    name: 'Car',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/car/order_list.vue')
  },
  {
    path: '/info',
    name: 'Info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/Info.vue')
  },
  {
    path: '/setting/index',
    name: 'Setting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/setting/Index.vue')
  },
  {
    path: '/setting/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/setting/Admin.vue')
  },
  {
    path: '/setting/group',
    name: 'AdminGroup',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/setting/Group.vue')
  },
  {
    path: '/setting/type',
    name: 'Type',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/setting/Type.vue')
  },
  {
    path: '/market/category',
    name: 'MarketCategory',
    component: () => import(/* webpackChunkName: "users" */ '../views/market/category.vue')
  },
  {
    path: '/market/product',
    name: 'MarketProduct',
    component: () => import(/* webpackChunkName: "users" */ '../views/market/product.vue')
  },
  {
    path: '/lithium/category',
    name: 'LithiumCategory',
    component: () => import(/* webpackChunkName: "users" */ '../views/lithium/category.vue')
  },
  {
    path: '/lithium/info',
    name: 'LithiumInfo',
    component: () => import(/* webpackChunkName: "users" */ '../views/lithium/info.vue')
  },
  {
    path: '/subscribe/list',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "users" */ '../views/subscribe/list.vue')
  },
  {
    path: '/version/index',
    name: 'Version',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../views/version/Index.vue')
  },
  //{
    //path: '/project',
    //name: 'Main',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/Project.vue'),
    //children: [
      //{
        //path: 'table/:app_no',
        //component: resolve => require(['@/views/Project/Table'], resolve),
      //}
    //]
  //}
]

const router = new VueRouter({
  routes
})

export default router